import Modal from "./modal";

export default class CreateSimulationModal extends Modal {
  constructor(companyId) {
    super("create-simulation-modal");
    this.companyId = companyId;
  }

  showModal(id) {
    const modal = this.getModal(id);
    modal.$form.reset();
    modal.clearDocuments().show();
  }

  getModal(id) {
    switch (id) {
      case "simulated-round":
        if (typeof peque.uploadDocumentModal === "undefined") {
          peque.uploadDocumentModal = new UploadDocumentModal(this.companyId);
        }
        return peque.uploadDocumentModal;
    }
  }
}
